// import React, { useState, useMemo, useEffect } from "react";
// import { Row, Col, Card, Button, Modal, Form } from "react-bootstrap";
// import { RBTable } from "@pallassystems/react-bootstrap-table";
// import Breadcrumb from "app/components/Breadcrumb";
// import { axios } from "fake-db/mock";

// export default function SetSalary() {
//   const [activeLeft, setActiveLeft] = useState("basic");
//   const [tableDataMap, setTableDataMap] = useState({
//     basic: [
//       {
//         monthYear: "2026-01",
//         payslipType: "Monthly",
//         basicsalary: 30000,
//         action: "View",
//       },
//     ],

//     allowances: [
//       {
//         monthYear: "2026-01",
//         allowanceType: "Taxable",
//         allowanceTitle: "HRA",
//         allowanceAmount: 5000,
//         action: "View",
//       },
//     ],

//     commissions: [
//       {
//         monthYear: "2026-01",
//         commissionTitle: "Sales",
//         commissions: 8000,
//         action: "View",
//       },
//     ],

//     loan: [
//       {
//         monthYear: "2026-01",
//         loan: "Home Loan",
//         loanAmount: 50000,
//         loanTime: "12 Months",
//         loanRemaining: 30000,
//         action: "View",
//       },
//     ],

//     statutory: [
//       {
//         monthYear: "2026-01",
//         deductionType: "PF",
//         title: "Provident Fund",
//         amount: 1800,
//         action: "View",
//       },
//     ],

//     other: [
//       {
//         monthYear: "2026-01",
//         title: "Bonus",
//         amount: 5000,
//         action: "View",
//       },
//     ],

//     overtime: [
//       {
//         monthYear: "2026-01",
//         title: "Night Shift",
//         noofDays: 5,
//         totalHours: 20,
//         rate: 300,
//         action: "View",
//       },
//     ],
//   });

//   const [showModal, setShowModal] = useState(false);
//   const [users, setUsers] = useState([]);

//   const [formData, setFormData] = useState({});

//   const [pensionData, setPensionData] = useState({
//     pensionType: "",
//     amount: 0,
//   });

//   //Left Menu
//   const leftMenu = [
//     { key: "basic", label: "Basic Salary", btn: "Add Basic Salary" },
//     { key: "allowances", label: "Allowances", btn: "Add Allowance" },
//     { key: "commissions", label: "Commissions", btn: "Add Commission" },
//     { key: "loan", label: "Loan", btn: "Add Loan" },
//     { key: "statutory", label: "Statutory Deductions", btn: "Add Deduction" },
//     { key: "other", label: "Other Payment", btn: "Add Payment" },
//     { key: "overtime", label: "Overtime", btn: "Add Overtime" },
//     { key: "pension", label: "Salary Pension", btn: "Add Pension" },
//   ];

//   const activeMenu = leftMenu.find((item) => item.key === activeLeft);
//   const tableData = tableDataMap[activeLeft] || [];
//   // Columns per menu
//   const tableColumns = {
//     basic: [
//       { accessorKey: "monthYear", header: "Month Year", searchable: true },
//       { accessorKey: "payslipType", header: "Payslip Type" },
//       { accessorKey: "basicsalary", header: "Basic Salary" },
//       {
//         accessorKey: "action",
//         header: "Action",
//         style: { width: "100px", textAlign: "center" },
//         Cell: () => {
//           return (
//             <div className="d-flex justify-content-start">
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   backgroundColor: "#663399",
//                   border: "none",
//                 }}
//                 onClick={() => {}}
//               >
//                 <i className="i-Eye text-18 text-white"></i>
//               </Button>
//             </div>
//           );
//         },
//       },
//     ],
//     allowances: [
//       { accessorKey: "monthYear", header: "Month-Year", searchable: true },
//       { accessorKey: "allowanceType", header: "Allowance Type" },
//       { accessorKey: "allowanceTitle", header: "Allowance Title" },
//       { accessorKey: "allowanceAmount", header: "Allowance Amount" },
//       {
//         accessorKey: "action",
//         header: "Action",
//         style: { width: "100px", textAlign: "center" },
//         Cell: () => {
//           return (
//             <div className="d-flex justify-content-start">
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   backgroundColor: "#663399",
//                   border: "none",
//                 }}
//                 onClick={() => {}}
//               >
//                 <i className="i-Eye text-18 text-white"></i>
//               </Button>
//             </div>
//           );
//         },
//       },
//     ],
//     commissions: [
//       { accessorKey: "monthYear", header: "Month-Year", searchable: true },
//       { accessorKey: "commissionTitle", header: "Commission Title" },
//       { accessorKey: "commissions", header: "Commissions" },
//       {
//         accessorKey: "action",
//         header: "Action",
//         style: { width: "100px", textAlign: "center" },
//         Cell: () => {
//           return (
//             <div className="d-flex justify-content-start">
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   backgroundColor: "#663399",
//                   border: "none",
//                 }}
//                 onClick={() => {}}
//               >
//                 <i className="i-Eye text-18 text-white"></i>
//               </Button>
//             </div>
//           );
//         },
//       },
//     ],

//     loan: [
//       { accessorKey: "monthYear", header: "Month-Year", searchable: true },
//       { accessorKey: "loan", header: "Loan " },
//       { accessorKey: "loanAmount", header: "Loan Amount" },
//       { accessorKey: "loanTime", header: "Loan Time" },
//       { accessorKey: "loanRemaining", header: "Loan Remaining" },
//       {
//         accessorKey: "action",
//         header: "Action",
//         style: { width: "100px", textAlign: "center" },
//         Cell: () => {
//           return (
//             <div className="d-flex justify-content-start">
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   backgroundColor: "#663399",
//                   border: "none",
//                 }}
//                 onClick={() => {}}
//               >
//                 <i className="i-Eye text-18 text-white"></i>
//               </Button>
//             </div>
//           );
//         },
//       },
//     ],
//     statutory: [
//       { accessorKey: "monthYear", header: "Month Year", searchable: true },
//       { accessorKey: "deductionType", header: "Deduction Type" },
//       { accessorKey: "title", header: "Title" },
//       { accessorKey: "amount", header: "Amount" },
//       {
//         accessorKey: "action",
//         header: "Action",
//         style: { width: "100px", textAlign: "center" },
//         Cell: () => {
//           return (
//             <div className="d-flex justify-content-start">
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   backgroundColor: "#663399",
//                   border: "none",
//                 }}
//                 onClick={() => {}}
//               >
//                 <i className="i-Eye text-18 text-white"></i>
//               </Button>
//             </div>
//           );
//         },
//       },
//     ],
//     other: [
//       { accessorKey: "monthYear", header: "Month Year", searchable: true },
//       { accessorKey: "title", header: "Title" },
//       { accessorKey: "amount", header: "Amount" },
//       {
//         accessorKey: "action",
//         header: "Action",
//         style: { width: "100px", textAlign: "center" },
//         Cell: () => {
//           return (
//             <div className="d-flex justify-content-start">
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   backgroundColor: "#663399",
//                   border: "none",
//                 }}
//                 onClick={() => {}}
//               >
//                 <i className="i-Eye text-18 text-white"></i>
//               </Button>
//             </div>
//           );
//         },
//       },
//     ],
//     overtime: [
//       { accessorKey: "monthYear", header: "Month Year", searchable: true },
//       { accessorKey: "title", header: "Title" },
//       { accessorKey: "noofDays", header: "Number Of Days" },
//       { accessorKey: "totalHours", header: "Total Hours" },
//       { accessorKey: "rate", header: "Rate" },
//       {
//         accessorKey: "action",
//         header: "Action",
//         style: { width: "100px", textAlign: "center" },
//         Cell: () => {
//           return (
//             <div className="d-flex justify-content-start">
//               <Button
//                 className="btn-icon d-flex align-items-center justify-content-center"
//                 style={{
//                   width: "32px",
//                   height: "32px",
//                   backgroundColor: "#663399",
//                   border: "none",
//                 }}
//                 onClick={() => {}}
//               >
//                 <i className="i-Eye text-18 text-white"></i>
//               </Button>
//             </div>
//           );
//         },
//       },
//     ],
//   };

//   const columns = useMemo(() => {
//     return tableColumns[activeLeft] || [];
//   }, [activeLeft]);

//   // Handle modal form change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   useEffect(() => {
//     axios.get("/api/user/all").then(({ data }) => {
//       const userList = data.map((item, ind) => ({
//         age: item.age,
//         index: ind + 1,
//         name: item.name,
//         email: item.email,
//         balance: item.balance,
//         company: item.company,
//       }));
//       setUsers(userList);
//     });
//   }, []);

//   const handlePensionChange = (e) => {
//     const { name, value } = e.target;
//     setPensionData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handlePensionAdd = () => {
//     console.log("PENSION DATA:", pensionData);

//     alert("Pension updated successfully");

//     setPensionData({
//       pensionType: "",
//       amount: 0,
//     });
//   };

//   // Handle Add button inside modal
//   const handleAdd = () => {
//     let newRow = {};

//     if (activeLeft === "basic") {
//       newRow = {
//         monthYear: formData.monthYear,
//         payslipType: formData.payslipType,
//         basicsalary: formData.amount,
//         action: "View",
//       };
//     }

//     if (activeLeft === "allowances") {
//       newRow = {
//         monthYear: formData.monthYear,
//         allowanceType: formData.allowanceType || "Rent",
//         allowanceTitle: formData.allowanceTitle || "House Rent",
//         allowanceAmount: formData.amount,
//         action: "View",
//       };
//     }

//     if (activeLeft === "commissions") {
//       newRow = {
//         monthYear: formData.monthYear,
//         commissionTitle: formData.commissionTitle,
//         commissions: formData.amount || 8000,
//         action: "View",
//       };
//     }

//     if (activeLeft === "loan") {
//       newRow = {
//         monthYear: formData.monthYear,
//         loan: formData.loanOption || "Home Loan",
//         loanAmount: formData.amount || 50000,
//         loanTime: formData.installments || "12 Months",
//         loanRemaining: formData.amount || 30000,
//         action: "View",
//       };
//     }

//     if (activeLeft === "statutory") {
//       newRow = {
//         monthYear: formData.monthYear,
//         deductionType: formData.deductionOption || "PF",
//         title: formData.deductionTitle || "Provident Fund",
//         amount: formData.amount,
//         action: "View",
//       };
//     }

//     if (activeLeft === "other") {
//       newRow = {
//         monthYear: formData.monthYear,
//         title: formData.title || "Bonus",
//         amount: formData.amount,
//         action: "View",
//       };
//     }

//     if (activeLeft === "overtime") {
//       newRow = {
//         monthYear: formData.monthYear,
//         title: formData.title || "Overtime",
//         noofDays: formData.noofDays || 0,
//         totalHours: formData.totalHours || 0,
//         rate: formData.rate || 0,
//         action: "View",
//       };
//     }

//     console.log("ADDING ROW:", activeLeft, newRow);

//     setTableDataMap((prev) => ({
//       ...prev,
//       [activeLeft]: [...prev[activeLeft], newRow],
//     }));

//     setShowModal(false);
//   };

//   return (
//     <section>
//       <Breadcrumb
//         routeSegments={[
//           { name: "Dashboard", path: "/" },
//           { name: "Set Salary" },
//         ]}
//       />

//       <Card className="p-4 shadow-sm">
//         <h6 className="mt-4 mb-3">Salary Info</h6>

//         <Row>
//           {/* Left Menu */}
//           <Col md={3}>
//             <Card>
//               {leftMenu.map((item) => (
//                 <div
//                   key={item.key}
//                   onClick={() => setActiveLeft(item.key)}
//                   className={`p-3 border-bottom cursor-pointer ${
//                     activeLeft === item.key ? "text-primary fw-semibold" : ""
//                   }`}
//                 >
//                   {item.label}
//                 </div>
//               ))}
//             </Card>
//           </Col>

//           {/* Right Side Content */}
//           <Col md={9}>
//             {/*Button – pension tab par nahi */}
//             {activeLeft !== "pension" && (
//               <div className="mb-3 d-flex justify-content-start">
//                 <Button
//                   className="btn-icon d-flex align-items-center text-white border-0 shadow-none"
//                   style={{ backgroundColor: "#663399" }}
//                   onClick={() => setShowModal(true)}
//                 >
//                   <span className="ul-btn__icon">
//                     <i className="i-Add text-18"></i>
//                   </span>
//                   <span className="ul-btn__text ml-2">{activeMenu?.btn}</span>
//                 </Button>
//               </div>
//             )}

//             {activeLeft !== "pension" && (
//               <RBTable
//                 data={tableData}
//                 key={activeLeft}
//                 columns={columns}
//                 varient="primary"
//                 footer={{ enablePagination: true }}
//                 header={{
//                   enableFilters: true,
//                   enableDensityToggle: true,
//                   enableExportButton: true,
//                 }}
//               />
//             )}

//             {/*  Pension UI*/}
//             {activeLeft === "pension" && (
//               <Card className="p-4 shadow-sm">
//                 <h6 className="mb-4">Update Pension</h6>

//                 <Row className="g-4">
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label>Pension Type</Form.Label>
//                       <Form.Select
//                         name="pensionType"
//                         value={pensionData.pensionType}
//                         onChange={handlePensionChange}
//                       >
//                         <option value="">Select Pension Type...</option>
//                         <option value="Fixed">Fixed</option>
//                         <option value="Percentage">Percentage</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label>(₹) Amount</Form.Label>
//                       <Form.Control
//                         type="number"
//                         name="amount"
//                         value={pensionData.amount}
//                         onChange={handlePensionChange}
//                         placeholder="0"
//                       />
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <div className="d-flex justify-content-end mt-4">
//                   <Button
//                     className="text-white border-0"
//                     onClick={handlePensionAdd}
//                     style={{
//                       backgroundColor: "#663399",
//                       padding: "8px 28px",
//                       borderRadius: "6px",
//                     }}
//                   >
//                     Add
//                   </Button>
//                 </div>
//               </Card>
//             )}
//           </Col>
//         </Row>
//       </Card>

//       <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>{activeMenu?.btn}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             {/* Basic Modal */}
//             {activeLeft === "basic" && (
//               <Row className="mb-3">
//                 {/* First Column */}
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Month Year *</Form.Label>
//                     <Form.Control
//                       type="month"
//                       name="monthYear"
//                       value={formData.monthYear}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Second Column */}
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Payslip Type *</Form.Label>
//                     <Form.Select
//                       name="payslipType"
//                       value={formData.payslipType}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select Payslip Type..</option>
//                       <option value="Monthly">Monthly</option>
//                       <option value="Hourly">Hourly</option>
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>

//                 {/* Third Column*/}
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>₹ Basic Salary *</Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="amount"
//                       value={formData.amount}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>
//               </Row>
//             )}
//             {/* Allowence Modal */}

//             {activeLeft === "allowances" && (
//               <Row className="g-5">
//                 {" "}

//                 {/* Month-Year */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Month Year *</Form.Label>
//                     <Form.Control
//                       type="month"
//                       name="monthYear"
//                       value={formData.monthYear || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>
//                 {/* Allowance Type */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Allowance Type *</Form.Label>
//                     <Form.Select
//                       name="allowanceType"
//                       value={formData.allowanceType || ""}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select Allowance Type...</option>
//                       <option value="Taxable">Taxable</option>
//                       <option value="Non-Taxable">Non-Taxable</option>
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//                 {/* Allowance Title */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Allowance Title *</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="allowanceTitle"
//                       value={formData.allowanceTitle || ""}
//                       onChange={handleChange}
//                       placeholder="Allowance"
//                     />
//                   </Form.Group>
//                 </Col>
//                 {/* Allowance Amount */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>₹ Allowance Amount *</Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="amount"
//                       value={formData.amount || ""}
//                       onChange={handleChange}
//                       placeholder="Allowance"
//                     />
//                   </Form.Group>
//                 </Col>
//               </Row>
//             )}

//             {/* Commission Modal */}
//             {activeLeft === "commissions" && (
//               <Row className="mb-3">
//                 {/* First Column */}
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Month Year *</Form.Label>
//                     <Form.Control
//                       type="month"
//                       name="monthYear"
//                       value={formData.monthYear}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Second Column */}
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Commission Title</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="commissionTitle"
//                       value={formData.commissionTitle || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Third Column*/}
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>₹ Commission Amount*</Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="amount"
//                       value={formData.amount}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>
//               </Row>
//             )}

//             {/* Loan Modal */}
//             {activeLeft === "loan" && (
//               <Row className="g-3">
//                 {/* Month-Year */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Month Year *</Form.Label>
//                     <Form.Control
//                       type="month"
//                       name="monthYear"
//                       value={formData.monthYear || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Loan Option */}
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Loan Option *</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="loanOption"
//                       value={formData.loanOption || ""}
//                       onChange={handleChange}
//                       placeholder="Select Loan Option..."
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Title */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Title *</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="title"
//                       value={formData.title || ""}
//                       onChange={handleChange}
//                       placeholder="Title"
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Amount */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>₹ Amount *</Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="amount"
//                       value={formData.amount || ""}
//                       onChange={handleChange}
//                       placeholder="Amount"
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Number of Installments */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Number of Installments</Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="installments"
//                       value={formData.installments || ""}
//                       onChange={handleChange}
//                       placeholder="Number"
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Reason */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Reason</Form.Label>
//                     <Form.Control
//                       as="textarea"
//                       rows={1}
//                       name="reason"
//                       value={formData.reason || ""}
//                       onChange={handleChange}
//                       placeholder="Reason"
//                     />
//                   </Form.Group>
//                 </Col>
//               </Row>
//             )}

//             {/* Statutary Modal */}
//             {activeLeft === "statutory" && (
//               <Row className="g-5">
//                 {/* Month-Year */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Month Year *</Form.Label>
//                     <Form.Control
//                       type="month"
//                       name="monthYear"
//                       value={formData.monthYear || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Deduction Option as text box */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Deduction Option *</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="deductionOption"
//                       value={formData.deductionOption || ""}
//                       onChange={handleChange}
//                       placeholder="Deduction"
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Deduction Title */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Deduction Title *</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="deductionTitle"
//                       value={formData.deductionTitle || ""}
//                       onChange={handleChange}
//                       placeholder="Deduction"
//                     />
//                   </Form.Group>
//                 </Col>

//                 {/* Deduction Amount */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>₹ Deduction Amount *</Form.Label>
//                     <Form.Control
//                       type="number"
//                       inputMode="numeric"
//                       pattern="[0-9]*"
//                       name="amount"
//                       value={formData.amount || ""}
//                       onChange={handleChange}
//                       placeholder="Deduction"
//                     />
//                   </Form.Group>
//                 </Col>
//               </Row>
//             )}

//             {/* Other Modal */}
//             {activeLeft === "other" && (
//               <Row className="g-5">
//                 {/* Month-Year */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Month Year *</Form.Label>
//                     <Form.Control
//                       type="month"
//                       name="monthYear"
//                       value={formData.monthYear || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Title*</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="title"
//                       value={formData.title || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>₹ Amount *</Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="amount"
//                       value={formData.amount || ""}
//                       onChange={handleChange}
//                       placeholder="Amount"
//                     />
//                   </Form.Group>
//                 </Col>
//               </Row>
//             )}

//             {/* Overtime Modal */}
//             {activeLeft === "overtime" && (
//               <Row className="g-5">
//                 {/* Month-Year */}
//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Month Year *</Form.Label>
//                     <Form.Control
//                       type="month"
//                       name="monthYear"
//                       value={formData.monthYear || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Title</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="title"
//                       value={formData.title || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Number of Days</Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="noofDays"
//                       value={formData.noofDays || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Total Hours</Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="totalHours"
//                       value={formData.totalHours || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>

//                 <Col md={6}>
//                   <Form.Group>
//                     <Form.Label>Rate</Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="rate"
//                       value={formData.rate || ""}
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>
//               </Row>
//             )}
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleAdd}>
//             Add
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </section>
//   );
// }

import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Form,
  Badge,
  Table,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import Breadcrumb from "app/components/Breadcrumb";
import api from "app/services/api";

// ─── constants ───────────────────────────────────────────────────────────────
const DEFAULT_EARNING = {
  component: "",
  type: "percentage",
  value: 0,
  is_active: 1,
  basedOn: "CTC",
};
const DEFAULT_DEDUCTION = {
  component: "",
  type: "percentage",
  value: 0,
  is_active: 1,
  basedOn: "CTC",
};
const DEFAULT_CONTRIBUTION = {
  component: "",
  type: "percentage",
  value: 0,
  is_active: 1,
  basedOn: "Basic",
};

// ─── helpers ─────────────────────────────────────────────────────────────────
const toNum = (v) => Number(v || 0);

const normaliseRows = (rows, defaults) =>
  rows.length
    ? rows.map((r) => ({
        ...r,
        value: toNum(r.value),
        is_active: toNum(r.is_active),
        basedOn: r.based_on || r.basedOn || defaults.basedOn,
      }))
    : [defaults];

// ─── TDS calculation ────────────────────────────────────────────────────────
const calcMonthlyTDS = (monthlyGross, monthlyEmployeePF) => {
  if (!monthlyGross || monthlyGross <= 0) return 0;
  const annual = monthlyGross * 12;
  const taxable = Math.max(0, annual - 50_000 - (monthlyEmployeePF || 0) * 12);

  let tax = 0;
  if (taxable <= 250_000) tax = 0;
  else if (taxable <= 500_000) tax = (taxable - 250_000) * 0.05;
  else if (taxable <= 1_000_000) tax = 12_500 + (taxable - 500_000) * 0.2;
  else tax = 112_500 + (taxable - 1_000_000) * 0.3;

  return (tax * 1.04) / 12;
};

const currency = new Intl.NumberFormat("en-IN", {
  style: "decimal",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const parseAmount = (value) => Number(value || 0);

const formatAmount = (value) => `₹ ${currency.format(Number(value || 0))}`;

const fmtMoney = (value) => currency.format(Number(value || 0));

const matchesBasic = (component = "") => /basic/i.test(component);

const calculateComponentAmount = (component, baseAmount, basicAmount) => {
  const value = parseAmount(component.value);
  const base = component.based_on === "Basic" ? basicAmount : baseAmount;

  if (component.type === "amount") {
    return value;
  }

  return (base * value) / 100;
};

const SectionCard = ({
  title,
  tone = "#663399",
  rows = [],
  loading = false,
}) => (
  <Card
    className="h-100 shadow-sm"
    style={{ borderRadius: 12, border: "1px solid #ece7f6" }}
  >
    <Card.Body>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: tone,
              textTransform: "uppercase",
              letterSpacing: ".08em",
            }}
          >
            {title}
          </div>
          <div style={{ fontSize: 12, color: "#6b7280" }}>
            {rows.length} component{rows.length === 1 ? "" : "s"}
          </div>
        </div>
        <Badge
          bg="light"
          text="dark"
          style={{ border: `1px solid ${tone}22`, color: tone }}
        >
          Live
        </Badge>
      </div>

      {loading ? (
        <div className="py-4 text-center text-muted">
          <Spinner animation="border" size="sm" className="me-2" />
          Loading components...
        </div>
      ) : rows.length === 0 ? (
        <div className="py-4 text-center text-muted" style={{ fontSize: 13 }}>
          No components found for this policy.
        </div>
      ) : (
        <Table
          responsive
          bordered
          size="sm"
          className="mb-0 align-middle"
          style={{ fontSize: 13 }}
        >
          <thead style={{ background: "#faf8ff" }}>
            <tr>
              <th>Component</th>
              <th style={{ width: 120 }}>Type</th>
              <th style={{ width: 120 }}>Base</th>
              <th style={{ width: 120 }} className="text-end">
                Value
              </th>
              <th style={{ width: 140 }} className="text-end">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={`${row.component}-${index}`}>
                <td style={{ fontWeight: 600 }}>
                  {row.component || "Unnamed"}
                </td>
                <td>
                  {row.type === "percentage" ? (
                    <Badge bg="info" style={{ fontSize: 11 }}>
                      Percentage
                    </Badge>
                  ) : (
                    <Badge bg="secondary" style={{ fontSize: 11 }}>
                      Amount
                    </Badge>
                  )}
                </td>
                <td>{row.baseLabel}</td>
                <td className="text-end">
                  {row.type === "percentage"
                    ? `${parseAmount(row.value)}%`
                    : formatAmount(row.value)}
                </td>
                <td className="text-end" style={{ fontWeight: 700 }}>
                  {formatAmount(row.amount)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Card.Body>
  </Card>
);

export default function SetSalary({ employee, onSalarySaved }) {
  const [salaryPolicies, setSalaryPolicies] = useState([]);
  const [selectedPolicyId, setSelectedPolicyId] = useState("");
  const [policyComponents, setPolicyComponents] = useState({
    earnings: [],
    deductions: [],
    contributions: [],
  });
  const [ctc, setCtc] = useState("");
  const [loadingPolicies, setLoadingPolicies] = useState(false);
  const [loadingPolicyDetails, setLoadingPolicyDetails] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const isHourlyEmployee = employee?.attendance_type === "Hourly";
useEffect(() => {
  console.log("Employee changed:", employee);
}, [employee]);
  useEffect(() => {
    let active = true;

    const fetchAssignedSalary = async () => {
      if (!employee?.id) {
        setCtc("");
        setSelectedPolicyId("");
        return;
      }

      try {
        const res = await api.get(`/api/employees/${employee.id}/salary`);

console.log("Salary API Response:", res.data);
        if (!active) return;

        if (res.data?.success && res.data?.has_salary && res.data?.data) {
           console.log("Setting policy:", res.data.data.policy_id);
  console.log("Setting CTC:", res.data.data.annual_ctc);

          setSelectedPolicyId(
            String(
              res.data.data.salary_policy_id || res.data.data.policy_id || "",
            ),
          );
          setCtc(
  String(
    res.data.data.yearly_ctc ??
    res.data.data.annual_ctc ??
    ""
  )
);
        } else {
          setSelectedPolicyId("");
          setCtc("");
        }
      } catch (err) {
        console.error("Failed to load assigned salary:", err);
        if (active) {
          setSelectedPolicyId("");
          setCtc("");
        }
      }
    };

    fetchAssignedSalary();

    return () => {
      active = false;
    };
  }, [employee]);
console.log("ctc state =", ctc);
console.log("selectedPolicyId =", selectedPolicyId);
console.log("employee =", employee);
  useEffect(() => {
    let active = true;

    const fetchPolicies = async () => {
      setLoadingPolicies(true);
      try {
        const res = await api.get("/api/salary-policies");
        if (!active) return;

        const list = Array.isArray(res.data?.data) ? res.data.data : [];
        setSalaryPolicies(list);
      } catch (err) {
        console.error("Failed to fetch salary policies:", err);
        if (active) {
          setMessage({
            type: "danger",
            text: "Unable to load salary policies.",
          });
        }
      } finally {
        if (active) setLoadingPolicies(false);
      }
    };

    fetchPolicies();

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    let active = true;

    const fetchPolicyComponents = async () => {
      if (!selectedPolicyId) {
        setPolicyComponents({
          earnings: [],
          deductions: [],
          contributions: [],
        });
        return;
      }

      setLoadingPolicyDetails(true);
      setMessage({ type: "", text: "" });

      try {
        const [earnRes, dedRes, conRes] = await Promise.all([
          api.get(`/api/salary-policies/${selectedPolicyId}/earnings`),
          api.get(`/api/salary-policies/${selectedPolicyId}/deductions`),
          api.get(`/api/salary-policies/${selectedPolicyId}/contributions`),
        ]);

        if (!active) return;

        setPolicyComponents({
          earnings: Array.isArray(earnRes.data?.data) ? earnRes.data.data : [],
          deductions: Array.isArray(dedRes.data?.data) ? dedRes.data.data : [],
          contributions: Array.isArray(conRes.data?.data)
            ? conRes.data.data
            : [],
        });
      } catch (err) {
        console.error("Failed to fetch salary policy details:", err);
        if (active) {
          setMessage({
            type: "danger",
            text: "Unable to load policy components.",
          });
          setPolicyComponents({
            earnings: [],
            deductions: [],
            contributions: [],
          });
        }
      } finally {
        if (active) setLoadingPolicyDetails(false);
      }
    };

    fetchPolicyComponents();

    return () => {
      active = false;
    };
  }, [selectedPolicyId]);

  const selectedPolicy = useMemo(
    () =>
      salaryPolicies.find(
        (policy) => String(policy.id) === String(selectedPolicyId),
      ),
    [salaryPolicies, selectedPolicyId],
  );

  // ✅ yearlyCTC is the source of truth from the input
  const yearlyCTC = parseAmount(ctc);
  const monthlyCTC = yearlyCTC / 12;
  const baseAmount = monthlyCTC; // Used only for monthly breakdown calculations

  const earnings = useMemo(() => {
    return policyComponents.earnings.map((component) => ({
      ...component,
      amount: calculateComponentAmount(component, baseAmount, baseAmount),
      baseLabel: "CTC",
    }));
  }, [policyComponents.earnings, baseAmount]);

  const basicAmount = useMemo(() => {
    const basicRow = earnings.find((row) => matchesBasic(row.component));
    return basicRow ? basicRow.amount : baseAmount;
  }, [earnings, baseAmount]);

  const deductions = useMemo(() => {
    return policyComponents.deductions.map((component) => ({
      ...component,
      amount: calculateComponentAmount(component, baseAmount, basicAmount),
      baseLabel: component.type === "percentage" ? "CTC" : "Fixed",
    }));
  }, [policyComponents.deductions, baseAmount, basicAmount]);

  const contributions = useMemo(() => {
    return policyComponents.contributions.map((component) => ({
      ...component,
      amount: calculateComponentAmount(component, baseAmount, basicAmount),
      baseLabel: component.based_on || "CTC",
    }));
  }, [policyComponents.contributions, baseAmount, basicAmount]);

  const earningsTotal = useMemo(
    () => earnings.reduce((sum, row) => sum + parseAmount(row.amount), 0),
    [earnings],
  );

  const deductionsTotal = useMemo(
    () => deductions.reduce((sum, row) => sum + parseAmount(row.amount), 0),
    [deductions],
  );

  const contributionsTotal = useMemo(
    () => contributions.reduce((sum, row) => sum + parseAmount(row.amount), 0),
    [contributions],
  );

  const estimatedNetPay = Math.max(0, earningsTotal - deductionsTotal);

  const handleApplySalary = async () => {
    if (!employee?.id) {
      setMessage({ type: "danger", text: "Employee not found." });
      return;
    }

    if (!selectedPolicyId) {
      setMessage({ type: "danger", text: "Select a salary policy first." });
      return;
    }

    // ✅ Validate against yearlyCTC, not baseAmount (which is monthly)
    if (!yearlyCTC || yearlyCTC <= 0) {
      setMessage({ type: "danger", text: "Enter a valid yearly CTC." });
      return;
    }

    setSaving(true);
    setMessage({ type: "", text: "" });

    // ✅ Send yearlyCTC (the actual yearly value entered by the user)
    const payload = {
      salary_policy_id: Number(selectedPolicyId),
      yearly_ctc: yearlyCTC,
    };

    try {
      const res = await api.put(
        `/api/employees/${employee.id}/salary`,
        payload,
      );

      if (res.data?.success) {
        setSelectedPolicyId(String(selectedPolicyId));
        // ✅ Restore the correct yearly value in the input
        setCtc(String(yearlyCTC));
      }

      if (typeof onSalarySaved === "function") {
        onSalarySaved({
          salary_policy_id: Number(selectedPolicyId),
          yearly_ctc: yearlyCTC, // ✅ Pass correct yearly value to callback
        });
      }

      // ✅ Success message shows correct yearly CTC
      setMessage({
        type: "success",
        text: `Yearly CTC (₹${fmtMoney(yearlyCTC)}) applied successfully.`,
      });
    } catch (err) {
      console.error("Apply salary error:", err);
      setMessage({
        type: "danger",
        text: err.response?.data?.message || "Failed to apply yearly CTC.",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <section>
      <Breadcrumb
        routeSegments={[
          { name: "Dashboard", path: "/" },
          { name: "Employees", path: "/employees" },
          { name: "Set Salary" },
        ]}
      />

      {isHourlyEmployee && (
        <Alert variant="info" className="mb-3">
          This employee is marked as hourly. Monthly salary policy assignment is
          disabled here.
        </Alert>
      )}

      {message.text && (
        <Alert variant={message.type || "info"} className="mb-3">
          {message.text}
        </Alert>
      )}

      <Card
        className="shadow-sm mb-3"
        style={{ borderRadius: 14, border: "1px solid #ece7f6" }}
      >
        <Card.Body>
          <Row className="g-4 align-items-start">
            <Col lg={4}>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#663399",
                  textTransform: "uppercase",
                  letterSpacing: ".08em",
                }}
              >
                Yearly CTC Setup
              </div>
              <h5 className="mt-2 mb-1" style={{ fontWeight: 700 }}>
                {employee
                  ? `${employee.first_name || ""} ${employee.last_name || ""}`.trim()
                  : "Employee"}
              </h5>
              <div className="text-muted" style={{ fontSize: 13 }}>
                {employee?.staff_id
                  ? `Staff ID: ${employee.staff_id}`
                  : "No staff ID available"}
              </div>

              <div
                className="mt-4 p-3 rounded-3"
                style={{
                  background:
                    "linear-gradient(180deg, #f9f6ff 0%, #ffffff 100%)",
                  border: "1px solid #ece7f6",
                }}
              >
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold" style={{ fontSize: 13 }}>
                    Salary Policy
                  </Form.Label>
                  <Form.Select
                    value={selectedPolicyId}
                    onChange={(e) => setSelectedPolicyId(e.target.value)}
                    disabled={loadingPolicies}
                  >
                    <option value="">Select salary policy...</option>
                    {salaryPolicies.map((policy) => (
                      <option key={policy.id} value={policy.id}>
                        {policy.title}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold" style={{ fontSize: 13 }}>
                    Yearly CTC (₹)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    value={ctc}
                    onChange={(e) => setCtc(e.target.value)}
                    placeholder="e.g. 600000"
                  />
                  {yearlyCTC > 0 && (
                    <Form.Text className="text-muted">
                      ≈ ₹{fmtMoney(Math.round(monthlyCTC * 100) / 100)} per
                      Month
                    </Form.Text>
                  )}
                </Form.Group>

                <div className="d-flex flex-column gap-2">
                  <div
                    className="d-flex justify-content-between"
                    style={{ fontSize: 13 }}
                  >
                    <span className="text-muted">Current policy</span>
                    <span style={{ fontWeight: 600 }}>
                      {selectedPolicy?.title || "Not applied"}
                    </span>
                  </div>
                  <div
                    className="d-flex justify-content-between"
                    style={{ fontSize: 13 }}
                  >
                    <span className="text-muted">Yearly CTC</span>
                    <span style={{ fontWeight: 700, color: "#663399" }}>
                      {formatAmount(yearlyCTC)}
                    </span>
                  </div>
                  {yearlyCTC > 0 && (
                    <div
                      className="d-flex justify-content-between"
                      style={{ fontSize: 13, marginTop: 6 }}
                    >
                      <span className="text-muted">Monthly gross</span>
                      <span style={{ fontWeight: 600, color: "#059669" }}>
                        ≈ {formatAmount(Math.round(monthlyCTC * 100) / 100)}
                      </span>
                    </div>
                  )}
                </div>

                <Button
                  className="w-100 mt-3"
                  style={{ backgroundColor: "#663399", border: "none" }}
                  onClick={handleApplySalary}
                  disabled={saving || !selectedPolicyId || !yearlyCTC}
                >
                  {saving ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Applying...
                    </>
                  ) : (
                    "Apply Yearly CTC"
                  )}
                </Button>
              </div>
            </Col>

            <Col lg={8}>
              <Row className="g-3 mb-3">
                <Col md={3}>
                  <Card
                    className="h-100"
                    style={{ borderRadius: 12, border: "1px solid #ece7f6" }}
                  >
                    <Card.Body>
                      <div
                        style={{
                          fontSize: 12,
                          color: "#6b7280",
                          textTransform: "uppercase",
                          letterSpacing: ".08em",
                        }}
                      >
                        Monthly CTC
                      </div>
                      <div
                        style={{
                          fontSize: 18,
                          fontWeight: 800,
                          color: "#111827",
                        }}
                      >
                        {formatAmount(monthlyCTC)}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card
                    className="h-100"
                    style={{ borderRadius: 12, border: "1px solid #ece7f6" }}
                  >
                    <Card.Body>
                      <div
                        style={{
                          fontSize: 12,
                          color: "#6b7280",
                          textTransform: "uppercase",
                          letterSpacing: ".08em",
                        }}
                      >
                        Monthly Earnings
                      </div>
                      <div
                        style={{
                          fontSize: 18,
                          fontWeight: 800,
                          color: "#111827",
                        }}
                      >
                        {formatAmount(earningsTotal)}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card
                    className="h-100"
                    style={{ borderRadius: 12, border: "1px solid #ece7f6" }}
                  >
                    <Card.Body>
                      <div
                        style={{
                          fontSize: 12,
                          color: "#6b7280",
                          textTransform: "uppercase",
                          letterSpacing: ".08em",
                        }}
                      >
                        Monthly Deductions
                      </div>
                      <div
                        style={{
                          fontSize: 18,
                          fontWeight: 800,
                          color: "#111827",
                        }}
                      >
                        {formatAmount(deductionsTotal)}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card
                    className="h-100"
                    style={{ borderRadius: 12, border: "1px solid #ece7f6" }}
                  >
                    <Card.Body>
                      <div
                        style={{
                          fontSize: 12,
                          color: "#6b7280",
                          textTransform: "uppercase",
                          letterSpacing: ".08em",
                        }}
                      >
                        Monthly Net Pay
                      </div>
                      <div
                        style={{
                          fontSize: 18,
                          fontWeight: 800,
                          color: "#111827",
                        }}
                      >
                        {formatAmount(estimatedNetPay)}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <Card
                className="shadow-sm mb-3"
                style={{ borderRadius: 12, border: "1px solid #ece7f6" }}
              >
                <Card.Body>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700 }}>
                        Selected policy preview
                      </div>
                      <div className="text-muted" style={{ fontSize: 13 }}>
                        {selectedPolicy?.title ||
                          "Select a salary policy to preview its monthly components."}
                      </div>
                    </div>
                    {loadingPolicyDetails && (
                      <Spinner animation="border" size="sm" />
                    )}
                  </div>
                </Card.Body>
              </Card>

              <Row className="g-3">
                <Col xl={6}>
                  <SectionCard
                    title="Earnings"
                    tone="#5b3fa0"
                    rows={earnings}
                    loading={loadingPolicyDetails && !earnings.length}
                  />
                </Col>
                <Col xl={6}>
                  <SectionCard
                    title="Deductions"
                    tone="#c4302b"
                    rows={deductions}
                    loading={loadingPolicyDetails && !deductions.length}
                  />
                </Col>
                <Col xl={12}>
                  <SectionCard
                    title="Contributions"
                    tone="#1d7a5f"
                    rows={contributions}
                    loading={loadingPolicyDetails && !contributions.length}
                  />
                </Col>
              </Row>

              <Card
                className="mt-3"
                style={{
                  borderRadius: 12,
                  border: "1px solid #ece7f6",
                  background: "#fcfbff",
                }}
              >
                <Card.Body className="d-flex flex-wrap gap-3 justify-content-between align-items-center">
                  <div>
                    <div
                      style={{
                        fontSize: 12,
                        color: "#6b7280",
                        textTransform: "uppercase",
                        letterSpacing: ".08em",
                      }}
                    >
                      Employer contributions
                    </div>
                    <div style={{ fontSize: 20, fontWeight: 800 }}>
                      {formatAmount(contributionsTotal)}
                    </div>
                  </div>
                  <div className="text-muted" style={{ fontSize: 13 }}>
                    CTC changes update the salary breakdown immediately. Hourly
                    salary remains separate.
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </section>
  );
}
